import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@monksflow/monks-ui';
import { PanelLeftIcon } from 'lucide-react';
import {
  settingsRailArea,
  useSettingsRailCollapsed,
  useSettingsRailStore,
} from './settings-rail.store';

/**
 * Collapses and expands the settings rail from a page's header. Sized like the header's other
 * leading control, so it sits flush with the content below on a `focus` header.
 */
export function SettingsRailToggle() {
  const { t } = useTranslation('admin');
  const { pathname } = useLocation();
  const area = settingsRailArea(pathname);
  const collapsed = useSettingsRailCollapsed(area);
  const setCollapsed = useSettingsRailStore((state) => state.setCollapsed);
  const label = collapsed
    ? t('admin.organizationSettings.expandRail')
    : t('admin.organizationSettings.collapseRail');

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon-lg"
            aria-label={label}
            aria-expanded={!collapsed}
            onClick={() => setCollapsed(area, !collapsed)}
            data-testid="settings-rail-header-toggle"
          >
            <PanelLeftIcon />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
